import { NavLink } from "react-router-dom";
import { styled } from "@mui/material/styles";

export const AppNavLink = styled(NavLink)(() => ({
  textDecoration: "none",
  color: "inherit",
}));
